"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useState, useEffect } from "react";
import api from "@/lib/api";

declare global {
  interface Window {
    __BRANCH_HOST__?: string;
  }
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  useEffect(() => {
    api.get("/settings/branch-host")
      .then((res) => {
        const branchHost = res.data?.branchHost;
        if (branchHost && typeof window !== "undefined") {
          window.__BRANCH_HOST__ = branchHost;
        }
      })
      .catch(() => {
        // Ignore errors - will fall back to window.location.hostname
      });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <TooltipProvider>
          {children}
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
